module.exports = __webpack_public_path__ + "static/media/UASIN.60a6e3f4.jpg";